import React, { Fragment, useEffect, useRef, useState } from "react";
import Link from "react-router-dom/Link";
import NavLink from "react-router-dom/NavLink";
import $ from "jquery";
import AsideInfo from "./AsideInfo";
import store from "../../common/store";
import {
  getAdmin,
  getGameLaunch,
  getGameList,
  getImages,
  getlistImgPath,
  getLobbylist,
  getLoginLobbylist,
  getTitle,
  isEmpty,
  toastr,
} from "../../common/cores";
import { headLogout } from "../../utils";
import connect from "react-redux/lib/connect/connect";
import { logoutUser } from "../../common/actions/userActions";
import { SetShowLeft } from "../../common/actions/userActions";
import LanguageSelection from "./LanguageSelection";
import { SetPageLoading } from "../../common/actions/pageAction";
import { isMobile } from "../../utils/utils";
const roomObj = {
  pageType: "other",
  RoomType: "other",
  sportType: "other",
  gameType: "other",
};

const roomData = {
  MessageType: "RoomType",
  data: roomObj,
};

const premenus1 = [
  {
    name: "스포츠",
    name_en: "SPORTS",
    path: "/sportsprematch",
    showImg: true,
    notready: false,
    value: "sport_prematch",
  },
  {
    name: "라이브",
    name_en: "SPORTS LIVE",
    path: "/sportslive",
    showImg: true,
    notready: false,
    value: "sport_live",
  },
  {
    name: "E-스포츠",
    name_en: "E-SPORTS",
    path: "/esports",
    showImg: true,
    notready: false,
    value: "esport_prematch",
  },
  {
    name: "카지노",
    name_en: "CASINO",
    path: "/casino",
    showImg: true,
    notready: false,
    value: "casino",
  },
  // {
  //   name: "호텔카지노",
  //   name_en: "HOTEL CASINO",
  //   path: "/hotelcasino",
  //   showImg: true
  // },
  {
    name: "슬롯",
    name_en: "SLOT",
    path: "/slot",
    showImg: true,
    notready: false,
    value: "slot",
  },
  {
    name: "미니게임",
    name_en: "MINI GAME",
    path: "/minigame",
    showImg: true,
    notready: false,
    value: "minigame",
  },
  {
    name: "벳365",
    name_en: "BET365GAME",
    path: "/betgame",
    showImg: false,
    notready: false,
    value: "betgame",
  },
];
const menus2 = [
  {
    name: "충전",
    name_en: "",
    path: "/deposit",
  },
  {
    name: "환전",
    name_en: "",
    path: "/withdraw",
  },
  {
    name: "공지사항",
    name_en: "",
    path: "/notices",
  },
  {
    name: "이벤트",
    name_en: "",
    path: "/events",
  },
  {
    name: "고객센터",
    name_en: "",
    path: "/inquiries/question",
  },
  {
    name: "마이페이지",
    name_en: "",
    path: "/myPage/history",
  },
];

const Headbar = (props) => {
  const {
    isAuthenticated,
    user,
    unreadNotes,
    casinoStatus,
    type,
    language,
    message,
  } = props;

  const [aside1, setAside1] = useState(false);
  const [aside2, setAside2] = useState(false);
  const [popup, setPopup] = useState(false);

  const [casinoLists, setCasinoLists] = useState([]);
  const [slotLists, setSlotLists] = useState([]);

  const popoverCasinoRef = useRef(null);
  const popoverSlotRef = useRef(null);
  const slotLinkRef = useRef(null);
  const casinoLinkRef = useRef(null);

  const [isCasinoHovered, setIsCasinoHovered] = useState(false);
  const [isSlotHovered, setIsSlotHovered] = useState(false);

  const [gameLists, setGameLists] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [search, setSearch] = useState("");
  const [imgLists, setImgLists] = useState([]);
  const gameType = "Slot";
  const [menuOpen, setMenuOpen] = useState(false);
  const [rightMenuOpen, setRightMenuOpen] = useState(false);
  const sidebarRef = useRef(null);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  const toggleRightMenu = () => {
    setRightMenuOpen(!rightMenuOpen);
  };
  const onChange = (e) => {
    const { name, value } = e.target;
    setSearch(value);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      console.log(sidebarRef.current);
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setMenuOpen(false); // Close the sidebar
        setRightMenuOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside, true);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside, true);
    };
  }, []);

  const onClickOpenModal = (list) => {
    if (!props.isAuthenticated)
      return toastr.warning(
        `${
          isEmpty(window.lang["로그인하시고 이용해주세요."])
            ? "로그인하시고 이용해주세요."
            : window.lang["로그인하시고 이용해주세요."]
        }`
      );
    props.SetPageLoading(true);
    setGameLists([]);
    const params = {
      ...list,
      type: gameType,
      username: user.loginId,
      vendor: list.vendor,
      // api: api
    };

    getGameList(params).then((data) => {
      // setApi(data.api);
      getImages(data.result, data.api).then((images) => {
        setImgLists(images);
        setGameLists(data.result);
        setOpenModal(!openModal);
        props.SetPageLoading(false);
      });
    });
  };

  const onClickList = (list) => {
    props.SetPageLoading(true);
    // console.log(localStorage);
    const params = {
      ...list,
      type: gameType,
      username: user.loginId,
      ipADD: localStorage.getItem("client-ip"),
    };
    getGameLaunch(params);
  };

  const onClickCloseModal = (list) => {
    // console.log(list);
    setOpenModal(!openModal);
  };

  const normalImage = "Logo.jpg";

  const getNormalImg = (e) => {
    e.target.src = `../images/${gameType}/${normalImage}`;
  };

  const getNormalOverImg = (e) => {
    // e.target.src=`../images/${type}/${normalImage}`
    e.target.style.display = "none";
  };

  const getModalImg = (e) => {
    e.target.src = `../images/${gameType}/${normalImage}`;
  };

  const handleCasinoMouseEnter = () => {
    setIsCasinoHovered(true);
    setIsSlotHovered(false);
  };

  const handleCasinoMouseLeave = () => {
    setIsCasinoHovered(false);
  };

  const handleSlotMouseEnter = () => {
    setIsSlotHovered(true);
    setIsCasinoHovered(false);
  };

  const handleSlotMouseLeave = () => {
    setIsSlotHovered(false);
  };

  const handleMouseLeave = (event) => {
    const relatedTarget = event.relatedTarget;
    if (!relatedTarget || !(relatedTarget instanceof Node)) {
      return;
    }

    if (
      popoverCasinoRef.current &&
      !popoverCasinoRef.current.contains(relatedTarget) &&
      popoverSlotRef.current &&
      !popoverSlotRef.current.contains(relatedTarget) &&
      casinoLinkRef.current &&
      !casinoLinkRef.current.contains(relatedTarget) &&
      slotLinkRef.current &&
      !slotLinkRef.current.contains(relatedTarget)
    ) {
      handleSlotMouseLeave();
      handleCasinoMouseLeave();
    }
  };

  useEffect(() => {
    document.addEventListener("mouseleave", handleMouseLeave);
    return () => {
      document.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, []);

  const onPopup = () => {
    setPopup(!popup);
  };

  const onClickMemMenu = (e) => {
    setMenuOpen(false);
    setRightMenuOpen(false);
    if (!isAuthenticated) {
      e.preventDefault();
      toastr.warning(
        `${
          isEmpty(window.lang["로그인하시고 이용해주세요."])
            ? "로그인하시고 이용해주세요."
            : window.lang["로그인하시고 이용해주세요."]
        }`
      );
    }
  };

  const getLists = (type) => {
    const params = {
      type: type,
    };
    getLoginLobbylist(params).then((data) => {
      if (type == "casino") {
        setCasinoLists(data.lobbyList);
      } else if (type == "Slot") {
        setSlotLists(data.lobbyList);
      }
    });
  };

  const getLoginLists = (type) => {
    props.SetPageLoading(true);
    const params = {
      type: type,
      token: user.loginId,
      username: user.loginId,
      status: casinoStatus,
    };
    getLobbylist(params).then((data) => {
      if (type == "casino") {
        setCasinoLists(data.lobbyList);
      } else if (type == "Slot") {
        setSlotLists(data.lobbyList);
      }
      props.SetPageLoading(false);
    });
  };

  useEffect(() => {
    if (isAuthenticated) {
      getLoginLists("casino");
      getLoginLists("Slot");
    } else {
      getLists("casino");
      getLists("Slot");
    }
  }, [isAuthenticated]);

  const onClickCasino = (list, event) => {
    event.preventDefault();
    if (!isAuthenticated) {
      toastr.warning(
        isEmpty(window.lang["로그인하시고 이용해주세요."])
          ? "로그인하시고 이용해주세요."
          : window.lang["로그인하시고 이용해주세요."]
      );
      return;
    }
    props.SetPageLoading(true);
    // console.log(localStorage);
    const params = {
      ...list,
      type: "casino",
      username: user.loginId,
      ipADD: localStorage.getItem("client-ip"),
    };
    getGameLaunch(params);
  };

  useEffect(() => {}, [language]);

  return (
    <Fragment>
      {isMobile() ? (
        <MobileHeadbar {...props} />
      ) : (
        <Fragment>
          <div className="header">
            <div className="header-snow" style={{ display: "none" }}>
              <div className="initial-snow">
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
                <div className="snow">❄</div>
              </div>
            </div>
            <div className="inner" id="theme_header">
              <div className="header_wrap">
                <div className="hamburger-menu" onClick={toggleMenu}>
                  <i
                    className="fa-solid fa-bars"
                    style={{ fontSize: "30px", color: "white" }}
                  ></i>
                </div>
                <ul className={`mem_menu ${menuOpen ? "open" : ""}`}>
                  <li className="bt_notice">
                    <Link to="/notices" onClick={onClickMemMenu}>
                      {isEmpty(window.lang["공지"])
                        ? "공지"
                        : window.lang["공지"]}
                    </Link>
                  </li>
                  <li className="bt_event">
                    <Link to="/events" onClick={onClickMemMenu}>
                      {isEmpty(window.lang["이벤트"])
                        ? "이벤트"
                        : window.lang["이벤트"]}
                    </Link>
                  </li>
                  <li className="bt_cs">
                    <Link to="/inquiries/question" onClick={onClickMemMenu}>
                      {isEmpty(window.lang["고객센터"])
                        ? "고객센터"
                        : window.lang["고객센터"]}
                    </Link>
                  </li>
                  <li className="bt_attendance" style={{ display: "block" }}>
                    <Link to="/attendance" onClick={onClickMemMenu}>
                      {isEmpty(window.lang["출석체크"])
                        ? "출석체크"
                        : window.lang["출석체크"]}
                    </Link>
                  </li>
                </ul>
                <div id="theme_logo" style={{ visibility: "visible" }}>
                  <a href="/">
                    <p className="theme_logo_img" id="main_top_logo"></p>
                  </a>
                </div>
                <div id="theme_login">
                  <div className="quick_menu_wrapper non_login">
                    <ul className="quick_menu">
                      <li className="notice_channel_wrap">
                        <span className="notice_channel_title">&nbsp;</span>
                        <a
                          href="https://t.me/"
                          className="notice_check_index notice_channel"
                          target="_blank"
                        >
                          <img src="../images/upload/2024/0306/jnBV_PxPg_rPVY_pCTk.png" />
                        </a>
                        <a
                          href="https://t.me/"
                          className="notice_check_index notice_channel"
                          target="_blank"
                        >
                          <img src="../images/upload/2024/0306/3Tuk_bLpf_LX0w_rVKh.png" />
                        </a>
                      </li>
                      <ul
                        className="mem_menu login"
                        style={{ display: isAuthenticated ? "flex" : "none" }}
                      >
                        <li
                          className="user_info pointer"
                          onClick={() => {
                            window.location.href = "/mypage";
                          }}
                        >
                          <p className="user user_nickname">
                            <img src="../images/upload/2023/1020/alo9_O2YI_XbuT_OsSJ.png" />
                            <span>{!isEmpty(user) && user.loginId}</span>
                          </p>
                          <p
                            className="money money_amount_header"
                            id="headerMoneyAmount"
                          >
                            <span className="">￦</span>
                            <span className="add-commas">
                              {!isEmpty(user.balance)
                                ? Number(user.balance.money).toLocaleString()
                                : "0"}
                            </span>
                          </p>
                        </li>
                      </ul>
                      <li
                        style={{ display: isAuthenticated ? "block" : "none" }}
                      >
                        <Link className="bt_deposit" to="/deposit">
                          {isEmpty(window.lang["입금"])
                            ? "입금"
                            : window.lang["입금"]}
                        </Link>
                      </li>
                      <li
                        style={{ display: isAuthenticated ? "block" : "none" }}
                      >
                        <Link className="bt_withdraw" to="/withdraw">
                          {isEmpty(window.lang["출금"])
                            ? "출금"
                            : window.lang["출금"]}
                        </Link>
                      </li>
                      <li
                        style={{
                          display: isAuthenticated ? "inline-block" : "none",
                        }}
                      >
                        <a className="bt_alarm" href="/messages"></a>
                        <div className="layer_list">
                          <ul>
                            <li>
                              <a href="/messages">
                                <span className="ico_quick04"></span>
                                <p>쪽지</p>
                                <em className="count noticeCount">
                                  {message.unreadNotes.length}
                                </em>
                              </a>
                            </li>
                            <li className="header_btn_csnotice">
                              <a href="/notices">
                                <span className="ico_quick05"></span>
                                <p>공지</p>
                              </a>
                            </li>
                            <li className="header_btn_csnotice">
                              <a href="/login">
                                <span className="ico_quick05"></span>
                                <p>로그아웃</p>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </li>
                      <li
                        className="flex-center"
                        style={{ display: isAuthenticated ? "none" : "block" }}
                      >
                        <Link className="bt_login" to="/login">
                          {isEmpty(window.lang["로그인"])
                            ? "로그인"
                            : window.lang["로그인"]}
                        </Link>
                      </li>
                      <li
                        style={{ display: isAuthenticated ? "none" : "block" }}
                      >
                        <Link className="bt_join" to="/register">
                          {isEmpty(window.lang["가입하기"])
                            ? "가입하기"
                            : window.lang["가입하기"]}
                        </Link>
                      </li>
                      <li className="flex-center" style={{ display: "flex" }}>
                        <LanguageSelection />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <ul className="gnb">
                <li
                  className="main"
                  ref={casinoLinkRef}
                  onMouseEnter={handleCasinoMouseEnter}
                  onMouseLeave={handleCasinoMouseLeave}
                >
                  <Link
                    focus-use=""
                    className="gameHyperLink on"
                    to="/casino"
                    gnb="0"
                    onClick={onClickMemMenu}
                  >
                    Live Casino
                  </Link>
                </li>
                <li
                  className="main"
                  ref={slotLinkRef}
                  onMouseEnter={handleSlotMouseEnter}
                  onMouseLeave={handleSlotMouseLeave}
                >
                  <Link
                    focus-use=""
                    className="gameHyperLink"
                    to="/Slot"
                    gnb="1"
                    onClick={onClickMemMenu}
                  >
                    Slot
                  </Link>
                </li>
                <li className="main">
                  <Link
                    focus-use=""
                    className="gameHyperLink"
                    to="/sportsprematch"
                    gnb="2"
                    onClick={onClickMemMenu}
                  >
                    Sports
                  </Link>
                </li>
                <li className="main">
                  <Link
                    focus-use=""
                    className="gameHyperLink"
                    to="/sportslive"
                    gnb="2"
                    onClick={onClickMemMenu}
                  >
                    Live
                  </Link>
                </li>
                <li className="main">
                  <Link
                    focus-use=""
                    className="gameHyperLink"
                    to="/esports"
                    gnb="2"
                    onClick={onClickMemMenu}
                  >
                    E-Sports
                  </Link>
                </li>
                <li className="main">
                  {" "}
                  <Link
                    focus-use=""
                    className="gameHyperLink"
                    to="/minigame"
                    gnb="2"
                    onClick={onClickMemMenu}
                  >
                    Mini-Games
                  </Link>
                </li>
              </ul>

              <div
                id="newSnb"
                className="newSnb"
                style={{ display: isCasinoHovered ? "block" : "none" }}
                onMouseEnter={handleCasinoMouseEnter}
                onMouseLeave={handleCasinoMouseLeave}
              >
                <div id="snb_bl">
                  <div
                    className="swiper-container snb_sl swiper-container-initialized swiper-container-horizontal"
                    id="swiper-head0"
                  >
                    <ul className="'swiper-wrapper sl sub0">
                      {casinoLists.map((list, index) => {
                        return (
                          <li data-use-true="" className=" " key={index}>
                            <a
                              className="gameHyperLink"
                              onClick={(event) => onClickCasino(list, event)}
                            >
                              <div className="newHotBadge">
                                {" "}
                                <span className="badge_G005001"></span>{" "}
                              </div>
                              <div className="gameTime_none"></div>{" "}
                              <img
                                src={getlistImgPath(list)}
                                over="/upload/2023/0516/vfze_Ki4i_J07k_PWdI.png?200x200c"
                                className="thumb no-drag"
                                alt=""
                              />{" "}
                              {getTitle(list)}
                            </a>{" "}
                          </li>
                        );
                      })}
                    </ul>{" "}
                    <span
                      className="swiper-notification"
                      aria-live="assertive"
                      aria-atomic="true"
                    ></span>
                  </div>
                </div>
              </div>
              <div
                id="newSnb"
                className="newSnb"
                style={{ display: isSlotHovered ? "block" : "none" }}
                onMouseEnter={handleSlotMouseEnter}
                onMouseLeave={handleSlotMouseLeave}
              >
                <div id="snb_bl">
                  <div className="swiper-container snb_sl" id="swiper-head1">
                    <ul className="'swiper-wrapper sl sub1">
                      {slotLists.map((list, index) => {
                        return (
                          <li data-use-true="" className=" " key={index}>
                            <a
                              className="gameHyperLink"
                              onClick={() => onClickOpenModal(list)}
                            >
                              <div className="newHotBadge">
                                {" "}
                                <span className="badge_G005001"></span>{" "}
                              </div>
                              <div className="gameTime_none"></div>{" "}
                              <img
                                src={getlistImgPath(list)}
                                over="/upload/2025/0106/Z0zD_yXtL_QsVd_erBd.png?200x200c"
                                className="thumb no-drag"
                                alt=""
                              />{" "}
                              {getTitle(list)}
                            </a>{" "}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              </div>
            </div>{" "}
            <button className="btnGameDetailHeader" id="closeHeader">
              {" "}
              <img
                src="/r/theme/center_logo/img/pc/arrow_down.png"
                alt=""
              />{" "}
            </button>
          </div>
          <div
            className=" align-items-center  justify-content-center slot-modal-back"
            style={{ display: !openModal ? "none" : "flex" }}
          >
            <div
              className="justify-content-center slot-modal game_list"
              style={{ listStyleType: "none" }}
            >
              <button
                data-v-57fde08a=""
                className="btn_close"
                onClick={onClickCloseModal}
              >
                <i
                  data-v-57fde08a=""
                  className="fa-light fa-close font-weight-light align-items-center justify-content-center color-white font-size-26 btn-close"
                  style={{ fontStyle: "normal" }}
                ></i>
              </button>
              <div className="slot-search ">
                <input
                  className="slot-search-input "
                  name="search"
                  type="text"
                  placeholder={
                    isEmpty(window.lang["검색"]) ? "검색" : window.lang["검색"]
                  }
                  value={search}
                  onChange={onChange}
                />
              </div>
              <div className="w-100 h-100 overflow-auto">
                <ul
                  className="slot_list justify-content-center flex-wrap"
                  style={{ width: "100%" }}
                >
                  {gameLists
                    .filter((list) => {
                      const patt = new RegExp(search, "i");
                      return patt.test(getTitle(list)) || isEmpty(search);
                    })
                    .map((list, index) => {
                      const imgIndex = imgLists.findIndex(
                        (img) => img.src === list.image
                      );
                      return (
                        <li
                          key={index}
                          style={{
                            listStyleType: "none",
                            marginBottom: "30px_",
                          }}
                        >
                          <a
                            style={{ backgroundColor: "#0f1621" }}
                            onClick={() => onClickList(list)}
                          >
                            <img
                              data-v-3348b8aa=""
                              className="slot-default-img"
                              src={imgLists[imgIndex].src}
                              alt=""
                              style={{
                                borderRadius: "10%",
                                minWidth: "145px_",
                              }}
                            />
                          </a>
                          <p className="text-center" style={{ color: "white" }}>
                            {getTitle(list)}
                          </p>
                        </li>
                      );
                    })}
                </ul>
              </div>
            </div>
          </div>
          <div
            className="align-items-center user-account-info"
            onClick={() => toggleRightMenu()}
          >
            <i className="fas fa-user-circle fa-2x text-light mr-2"></i>
          </div>
          {menuOpen && (
            <MobileSidebar
              ref={sidebarRef}
              isAuthenticated={isAuthenticated}
              menuOpen={menuOpen}
              message={message}
              toggleMenu={toggleMenu}
              onClickMemMenu={onClickMemMenu}
              user={user}
              casinoLinkRef={casinoLinkRef}
              handleCasinoMouseEnter={handleCasinoMouseEnter}
              handleCasinoMouseLeave={handleCasinoMouseLeave}
              handleSlotMouseEnter={handleCasinoMouseEnter}
              handleSlotMouseLeave={handleSlotMouseLeave}
              slotLinkRef={slotLinkRef}
            />
          )}
          {rightMenuOpen && (
            <MobileRightSidebar
              ref={sidebarRef}
              isAuthenticated={isAuthenticated}
              menuOpen={rightMenuOpen}
              message={message}
              toggleMenu={toggleRightMenu}
              onClickMemMenu={onClickMemMenu}
              user={user}
              casinoLinkRef={casinoLinkRef}
              handleCasinoMouseEnter={handleCasinoMouseEnter}
              handleCasinoMouseLeave={handleCasinoMouseLeave}
              handleSlotMouseEnter={handleCasinoMouseEnter}
              handleSlotMouseLeave={handleSlotMouseLeave}
              slotLinkRef={slotLinkRef}
            />
          )}
        </Fragment>
      )}
    </Fragment>
  );
};

const MobileHeadbar = (props) => {
  const {
    isAuthenticated,
    user,
    unreadNotes,
    casinoStatus,
    type,
    language,
    message,
  } = props;

  const [aside1, setAside1] = useState(false);
  const [aside2, setAside2] = useState(false);
  const [popup, setPopup] = useState(false);

  const [casinoLists, setCasinoLists] = useState([]);
  const [slotLists, setSlotLists] = useState([]);

  const popoverCasinoRef = useRef(null);
  const popoverSlotRef = useRef(null);
  const slotLinkRef = useRef(null);
  const casinoLinkRef = useRef(null);

  const [isCasinoHovered, setIsCasinoHovered] = useState(false);
  const [isSlotHovered, setIsSlotHovered] = useState(false);

  const [gameLists, setGameLists] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [search, setSearch] = useState("");
  const [imgLists, setImgLists] = useState([]);
  const gameType = "Slot";
  const [menuOpen, setMenuOpen] = useState(false);
  const [rightMenuOpen, setRightMenuOpen] = useState(false);
  const sidebarRef = useRef(null);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  const toggleRightMenu = () => {
    setRightMenuOpen(!rightMenuOpen);
  };
  const onChange = (e) => {
    const { name, value } = e.target;
    setSearch(value);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      console.log(sidebarRef.current);
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setMenuOpen(false); // Close the sidebar
        setRightMenuOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside, true);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside, true);
    };
  }, []);

  const onClickOpenModal = (list) => {
    if (!props.isAuthenticated)
      return toastr.warning(
        `${
          isEmpty(window.lang["로그인하시고 이용해주세요."])
            ? "로그인하시고 이용해주세요."
            : window.lang["로그인하시고 이용해주세요."]
        }`
      );
    props.SetPageLoading(true);
    setGameLists([]);
    const params = {
      ...list,
      type: gameType,
      username: user.loginId,
      vendor: list.vendor,
      // api: api
    };

    getGameList(params).then((data) => {
      // setApi(data.api);
      getImages(data.result, data.api).then((images) => {
        setImgLists(images);
        setGameLists(data.result);
        setOpenModal(!openModal);
        props.SetPageLoading(false);
      });
    });
  };

  const onClickList = (list) => {
    props.SetPageLoading(true);
    // console.log(localStorage);
    const params = {
      ...list,
      type: gameType,
      username: user.loginId,
      ipADD: localStorage.getItem("client-ip"),
    };
    getGameLaunch(params);
  };

  const onClickCloseModal = (list) => {
    // console.log(list);
    setOpenModal(!openModal);
  };

  const normalImage = "Logo.jpg";

  const getNormalImg = (e) => {
    e.target.src = `../images/${gameType}/${normalImage}`;
  };

  const getNormalOverImg = (e) => {
    // e.target.src=`../images/${type}/${normalImage}`
    e.target.style.display = "none";
  };

  const getModalImg = (e) => {
    e.target.src = `../images/${gameType}/${normalImage}`;
  };

  const handleCasinoMouseEnter = () => {
    setIsCasinoHovered(true);
    setIsSlotHovered(false);
  };

  const handleCasinoMouseLeave = () => {
    setIsCasinoHovered(false);
  };

  const handleSlotMouseEnter = () => {
    setIsSlotHovered(true);
    setIsCasinoHovered(false);
  };

  const handleSlotMouseLeave = () => {
    setIsSlotHovered(false);
  };

  const handleMouseLeave = (event) => {
    const relatedTarget = event.relatedTarget;
    if (!relatedTarget || !(relatedTarget instanceof Node)) {
      return;
    }

    if (
      popoverCasinoRef.current &&
      !popoverCasinoRef.current.contains(relatedTarget) &&
      popoverSlotRef.current &&
      !popoverSlotRef.current.contains(relatedTarget) &&
      casinoLinkRef.current &&
      !casinoLinkRef.current.contains(relatedTarget) &&
      slotLinkRef.current &&
      !slotLinkRef.current.contains(relatedTarget)
    ) {
      handleSlotMouseLeave();
      handleCasinoMouseLeave();
    }
  };

  useEffect(() => {
    document.addEventListener("mouseleave", handleMouseLeave);
    return () => {
      document.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, []);

  const onPopup = () => {
    setPopup(!popup);
  };

  const onClickMemMenu = (e) => {
    setMenuOpen(false);
    setRightMenuOpen(false);
    if (!isAuthenticated) {
      e.preventDefault();
      toastr.warning(
        `${
          isEmpty(window.lang["로그인하시고 이용해주세요."])
            ? "로그인하시고 이용해주세요."
            : window.lang["로그인하시고 이용해주세요."]
        }`
      );
    }
  };

  const getLists = (type) => {
    const params = {
      type: type,
    };
    getLoginLobbylist(params).then((data) => {
      if (type == "casino") {
        setCasinoLists(data.lobbyList);
      } else if (type == "Slot") {
        setSlotLists(data.lobbyList);
      }
    });
  };

  const getLoginLists = (type) => {
    props.SetPageLoading(true);
    const params = {
      type: type,
      token: user.loginId,
      username: user.loginId,
      status: casinoStatus,
    };
    getLobbylist(params).then((data) => {
      if (type == "casino") {
        setCasinoLists(data.lobbyList);
      } else if (type == "Slot") {
        setSlotLists(data.lobbyList);
      }
      props.SetPageLoading(false);
    });
  };

  useEffect(() => {
    if (isAuthenticated) {
      getLoginLists("casino");
      getLoginLists("Slot");
    } else {
      getLists("casino");
      getLists("Slot");
    }
  }, [isAuthenticated]);

  const onClickCasino = (list, event) => {
    event.preventDefault();
    if (!isAuthenticated) {
      toastr.warning(
        isEmpty(window.lang["로그인하시고 이용해주세요."])
          ? "로그인하시고 이용해주세요."
          : window.lang["로그인하시고 이용해주세요."]
      );
      return;
    }
    props.SetPageLoading(true);
    // console.log(localStorage);
    const params = {
      ...list,
      type: "casino",
      username: user.loginId,
      ipADD: localStorage.getItem("client-ip"),
    };
    getGameLaunch(params);
  };

  useEffect(() => {}, [language]);

  return (
    <Fragment>
      <div className="header" style={{ top: 0 }}>
        <div className="inner" id="theme_header">
          <div
            className="header_wrap"
            style={{ justifyContent: "flex-end", minHeight: "60px" }}
          >
            <div id="theme_login">
              <div className="quick_menu_wrapper non_login">
                <ul className="quick_menu m-0">
                  <li
                    className="header_btn_csnotice menu"
                    style={{ display: isAuthenticated ? "flex" : "none" }}
                  >
                    <a href="/login" className="bt_login">
                      {isEmpty(window.lang["로그아웃"])
                        ? "로그아웃"
                        : window.lang["로그아웃"]}
                    </a>
                  </li>
                  <li
                    className="flex-center"
                    style={{ display: isAuthenticated ? "none" : "block" }}
                  >
                    <Link className="bt_login" to="/login">
                      {isEmpty(window.lang["로그인"])
                        ? "로그인"
                        : window.lang["로그인"]}
                    </Link>
                  </li>
                  <li style={{ display: isAuthenticated ? "none" : "block" }}>
                    <Link className="bt_join" to="/register">
                      {isEmpty(window.lang["가입하기"])
                        ? "가입하기"
                        : window.lang["가입하기"]}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div
              className="align-items-center pr-3 d-flex justify-content-center "
              onClick={() => toggleRightMenu()}
            >
              <i className="fas fa-bars fa-2x text-light mr-2"></i>
            </div>
          </div>
        </div>
      </div>
      <div style={{ marginTop: "65px" }}>
        <div>
          <div className="marquee" style={{ background: "#222" }}>
            <div>
              <p
                className="txt"
                id="lineMsg"
                style={{ color: "rgb(255, 255, 255)" }}
              >
                {isEmpty(
                  window.lang[
                    "안녕하세요 오늘도 찾아주셔서 감사합니다.오늘도 고객님의 행운을 기원 합니다.!!"
                  ]
                )
                  ? "안녕하세요 오늘도 찾아주셔서 감사합니다.오늘도 고객님의 행운을 기원 합니다.!!"
                  : window.lang[
                      "안녕하세요 오늘도 찾아주셔서 감사합니다.오늘도 고객님의 행운을 기원 합니다.!!"
                    ]}
              </p>
            </div>
          </div>
          <MobileMenubar />

          <div
            id="newSnb"
            className="newSnb"
            style={{ display: isCasinoHovered ? "block" : "none" }}
            onMouseEnter={handleCasinoMouseEnter}
            onMouseLeave={handleCasinoMouseLeave}
          >
            <div id="snb_bl">
              <div
                className="swiper-container snb_sl swiper-container-initialized swiper-container-horizontal"
                id="swiper-head0"
              >
                <ul className="'swiper-wrapper sl sub0">
                  {casinoLists.map((list, index) => {
                    return (
                      <li data-use-true="" className=" " key={index}>
                        <a
                          className="gameHyperLink"
                          onClick={(event) => onClickCasino(list, event)}
                        >
                          <div className="newHotBadge">
                            {" "}
                            <span className="badge_G005001"></span>{" "}
                          </div>
                          <div className="gameTime_none"></div>{" "}
                          <img
                            src={getlistImgPath(list)}
                            over="/upload/2023/0516/vfze_Ki4i_J07k_PWdI.png?200x200c"
                            className="thumb no-drag"
                            alt=""
                          />{" "}
                          {getTitle(list)}
                        </a>{" "}
                      </li>
                    );
                  })}
                </ul>{" "}
                <span
                  className="swiper-notification"
                  aria-live="assertive"
                  aria-atomic="true"
                ></span>
              </div>
            </div>
          </div>
          <div
            id="newSnb"
            className="newSnb"
            style={{ display: isSlotHovered ? "block" : "none" }}
            onMouseEnter={handleSlotMouseEnter}
            onMouseLeave={handleSlotMouseLeave}
          >
            <div id="snb_bl">
              <div className="swiper-container snb_sl" id="swiper-head1">
                <ul className="'swiper-wrapper sl sub1">
                  {slotLists.map((list, index) => {
                    return (
                      <li data-use-true="" className=" " key={index}>
                        <a
                          className="gameHyperLink"
                          onClick={() => onClickOpenModal(list)}
                        >
                          <div className="newHotBadge">
                            {" "}
                            <span className="badge_G005001"></span>{" "}
                          </div>
                          <div className="gameTime_none"></div>{" "}
                          <img
                            src={getlistImgPath(list)}
                            over="/upload/2025/0106/Z0zD_yXtL_QsVd_erBd.png?200x200c"
                            className="thumb no-drag"
                            alt=""
                          />{" "}
                          {getTitle(list)}
                        </a>{" "}
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>{" "}
        <button className="btnGameDetailHeader" id="closeHeader">
          <img src="/r/theme/center_logo/img/pc/arrow_down.png" alt="" />{" "}
        </button>
      </div>
      <div
        className=" align-items-center  justify-content-center slot-modal-back"
        style={{ display: !openModal ? "none" : "flex" }}
      >
        <div
          className="justify-content-center slot-modal game_list"
          style={{ listStyleType: "none" }}
        >
          <button
            data-v-57fde08a=""
            className="btn_close"
            onClick={onClickCloseModal}
          >
            <i
              data-v-57fde08a=""
              className="fa-light fa-close font-weight-light align-items-center justify-content-center color-white font-size-26 btn-close"
              style={{ fontStyle: "normal" }}
            ></i>
          </button>
          <div className="slot-search ">
            <input
              className="slot-search-input "
              name="search"
              type="text"
              placeholder={
                isEmpty(window.lang["검색"]) ? "검색" : window.lang["검색"]
              }
              value={search}
              onChange={onChange}
            />
          </div>
          <div className="w-100 h-100 overflow-auto">
            <ul
              className="slot_list justify-content-center flex-wrap"
              style={{ width: "100%" }}
            >
              {gameLists
                .filter((list) => {
                  const patt = new RegExp(search, "i");
                  return patt.test(getTitle(list)) || isEmpty(search);
                })
                .map((list, index) => {
                  const imgIndex = imgLists.findIndex(
                    (img) => img.src === list.image
                  );
                  return (
                    <li
                      key={index}
                      style={{ listStyleType: "none", marginBottom: "30px_" }}
                    >
                      <a
                        style={{ backgroundColor: "#0f1621" }}
                        onClick={() => onClickList(list)}
                      >
                        <img
                          data-v-3348b8aa=""
                          className="slot-default-img"
                          src={imgLists[imgIndex].src}
                          alt=""
                          style={{ borderRadius: "10%", minWidth: "145px_" }}
                        />
                      </a>
                      <p className="text-center" style={{ color: "white" }}>
                        {getTitle(list)}
                      </p>
                    </li>
                  );
                })}
            </ul>
          </div>
        </div>
      </div>
      <MobileRightSidebar
        user={user}
        menuOpen={rightMenuOpen}
        isAuthenticated={isAuthenticated}
        message={message}
        toggleMenu={toggleRightMenu}
        onClickMemMenu={onClickMemMenu}
      />
    </Fragment>
  );
};

const MobileMenubar = () => {
  const menuItems = [
    {
      icon: "/images/upload/mobile/UuXa_U7v8_iXIz_nPSd.png",
      label: isEmpty(window.lang["라이브카지노"])
        ? "라이브카지노"
        : window.lang["라이브카지노"],
      path: "/casino",
    },
    {
      icon: "/images/upload/mobile/2vY6_Z35M_K6Oi_vgqT.png",
      label: isEmpty(window.lang["슬롯"]) ? "슬롯" : window.lang["슬롯"],
      path: "/Slot",
    },
    {
      icon: "/images/upload/mobile/qgqC_Y1WH_NwGe_Fx6P.png",
      label: isEmpty(window.lang["스포츠"]) ? "스포츠" : window.lang["스포츠"],
      path: "/sportsprematch",
    },
    {
      icon: "/images/upload/mobile/television_175745061.png",
      label: isEmpty(window.lang["라이브"]) ? "라이브" : window.lang["라이브"],
      path: "/sportslive",
    },
    {
      icon: "/images/upload/mobile/JWBE_2zXi_FSX2_3kfT.png",
      label: isEmpty(window.lang["E-스포츠"])
        ? "E-스포츠"
        : window.lang["E-스포츠"],
      path: "/esports",
    },
    {
      icon: "/images/upload/mobile/vptQ_m9A2_JpIF_WL7j.png",
      label: isEmpty(window.lang["미니게임"])
        ? "미니게임"
        : window.lang["미니게임"],
      path: "/minigame",
    },
  ];
  const containerRef = useRef(null);
  const [showPrev, setShowPrev] = useState(false);
  const [showNext, setShowNext] = useState(false);

  const checkOverflow = () => {
    const el = containerRef.current;
    if (!el) return;
    setShowPrev(el.scrollLeft > 5);
    setShowNext(el.scrollLeft + el.clientWidth < el.scrollWidth - 5);
  };

  const scrollLeft = () => {
    containerRef.current.scrollBy({
      left: -350,
      behavior: "smooth",
    });
  };

  const scrollRight = () => {
    containerRef.current.scrollBy({ left: 350, behavior: "smooth" });
  };

  useEffect(() => {
    checkOverflow();
    const el = containerRef.current;
    if (el) el.addEventListener("scroll", checkOverflow);
    window.addEventListener("resize", checkOverflow);
    return () => {
      if (el) el.removeEventListener("scroll", checkOverflow);
      window.removeEventListener("resize", checkOverflow);
    };
  }, []);

  return (
    <div
      className="menu-wrapper"
      style={{ borderTop: "2px solid", borderBottom: "2px solid", padding: 8 }}
    >
      {showPrev && (
        <div className="fade fade-left" onClick={scrollLeft}>
          <i
            className="fa-solid fa-chevron-left"
            style={{ color: "#fff", fontWeight: 300 }}
          ></i>
        </div>
      )}
      <div className="menu-container" ref={containerRef}>
        {menuItems.map((item, idx) => (
          <div
            className="menu-item"
            key={idx}
            onClick={() => (window.location.href = item.path)}
          >
            <img
              src={item.icon}
              alt={item.label}
              className="menu-icon"
              style={{ width: 30, objectFit: "contain" }}
            />
            <div className="menu-label">{item.label}</div>
          </div>
        ))}
      </div>
      {showNext && (
        <div className="fade fade-right" onClick={() => scrollRight()}>
          <i
            className="fa-solid fa-chevron-right"
            style={{ color: "#fff", fontWeight: 300 }}
          ></i>
        </div>
      )}
    </div>
  );
};

const MobileSidebar = React.forwardRef(
  ({ menuOpen, toggleMenu, onClickMemMenu }, ref) => {
    return (
      <Fragment>
        <div
          className="overlay"
          style={{ display: menuOpen ? "block" : "none" }}
        />
        <div
          className="hamburger-menu"
          onClick={toggleMenu}
          style={{
            zIndex: 1001,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <i
            className="fa-solid fa-xmark"
            style={{ fontSize: "35px", color: "white" }}
          ></i>
        </div>

        <div
          ref={ref}
          className={`sidebar-hamburger ${menuOpen ? "open" : ""} ${
            menuOpen ? "active" : ""
          }`}
          style={{ zIndex: 1000 }}
        >
          <div
            style={{
              overflowY: "scroll",
              marginTop: "50px",
              height: "calc(80vh)",
            }}
          >
            <ul className="">
              <li
                className="menu"
                // ref={casinoLinkRef}
                // onMouseEnter={handleCasinoMouseEnter}
                // onMouseLeave={handleCasinoMouseLeave}
              >
                <i className="fas fa-spade"></i>
                <Link
                  focus-use=""
                  className="gameHyperLink on"
                  to="/casino"
                  gnb="0"
                  onClick={onClickMemMenu}
                >
                  {isEmpty(window.lang["라이브카지노"])
                    ? "라이브카지노"
                    : window.lang["라이브카지노"]}
                </Link>
              </li>
              <li
                className="menu"
                // ref={slotLinkRef}
                // onMouseEnter={handleSlotMouseEnter}
                // onMouseLeave={handleSlotMouseLeave}
              >
                <i className="fas fa-dice"></i>
                <Link
                  focus-use=""
                  className="gameHyperLink"
                  to="/Slot"
                  gnb="1"
                  onClick={onClickMemMenu}
                >
                  {isEmpty(window.lang["슬롯"]) ? "슬롯" : window.lang["슬롯"]}{" "}
                </Link>
              </li>
              <li className="menu">
                <i className="fas fa-futbol"></i>
                <Link
                  focus-use=""
                  className="gameHyperLink"
                  to="/sportsprematch"
                  gnb="2"
                  onClick={onClickMemMenu}
                >
                  {isEmpty(window.lang["스포츠"])
                    ? "스포츠"
                    : window.lang["스포츠"]}{" "}
                </Link>
              </li>
              <li className="menu">
                <i className="fas fa-video"></i>
                <Link
                  focus-use=""
                  className="gameHyperLink"
                  to="/sportslive"
                  gnb="2"
                  onClick={onClickMemMenu}
                >
                  {isEmpty(window.lang["라이브"])
                    ? "라이브"
                    : window.lang["라이브"]}{" "}
                </Link>
              </li>
              <li className="menu">
                <i className="fas fa-gamepad"></i>
                <Link
                  focus-use=""
                  className="gameHyperLink"
                  to="/esports"
                  gnb="2"
                  onClick={onClickMemMenu}
                >
                  {isEmpty(window.lang["E-스포츠"])
                    ? "E-스포츠"
                    : window.lang["E-스포츠"]}{" "}
                </Link>
              </li>
              <li className="menu">
                <i className="fas fa-clone"></i>
                <Link
                  focus-use=""
                  className="gameHyperLink"
                  to="/minigame"
                  gnb="2"
                  onClick={onClickMemMenu}
                >
                  {isEmpty(window.lang["미니게임"])
                    ? "미니게임"
                    : window.lang["미니게임"]}
                </Link>
              </li>

              <li className="menu">
                <i className="fas fa-bullhorn"></i>
                <Link to="/notices" onClick={onClickMemMenu}>
                  {isEmpty(window.lang["공지"]) ? "공지" : window.lang["공지"]}
                </Link>
              </li>
              <li className="menu">
                <i className="fas fa-gift"></i>
                <Link to="/events" onClick={onClickMemMenu}>
                  {isEmpty(window.lang["이벤트"])
                    ? "이벤트"
                    : window.lang["이벤트"]}
                </Link>
              </li>
              <li className="menu">
                <i className="fas fa-headset"></i>
                <Link to="/inquiries/question" onClick={onClickMemMenu}>
                  {isEmpty(window.lang["고객센터"])
                    ? "고객센터"
                    : window.lang["고객센터"]}
                </Link>
              </li>
              <li className="menu">
                <i className="fas fa-clipboard-check"></i>
                <Link to="/attendance" onClick={onClickMemMenu}>
                  {isEmpty(window.lang["출석체크"])
                    ? "출석체크"
                    : window.lang["출석체크"]}
                </Link>
              </li>

              <li
                className="notice_channel_wrap "
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  marginTop: "20px",
                }}
              >
                <span className="notice_channel_title">&nbsp;</span>
                <a
                  href="https://t.me/"
                  className="notice_check_index notice_channel"
                  target="_blank"
                >
                  <img
                    src="../images/upload/2024/0306/jnBV_PxPg_rPVY_pCTk.png"
                    width={40}
                  />
                </a>
                <a
                  href="https://t.me/"
                  className="notice_check_index notice_channel"
                  target="_blank"
                >
                  <img
                    src="../images/upload/2024/0306/3Tuk_bLpf_LX0w_rVKh.png"
                    width={40}
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </Fragment>
    );
  }
);

const MobileRightSidebar = React.forwardRef(
  (
    { user, menuOpen, isAuthenticated, message, toggleMenu, onClickMemMenu },
    ref
  ) => {
    return (
      <Fragment>
        <div
          className="overlay"
          style={{ display: menuOpen ? "block" : "none" }}
        />
        <div
          ref={ref}
          className={`right-sidebar-hamburger ${menuOpen ? "open" : ""} ${
            menuOpen ? "active" : ""
          }`}
        >
          <div
            style={{
              height: 65,
              background: "#000",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div className="pl-1" style={{ width: 50, textAlign: "center" }}>
              <i
                className="fa fa-close"
                style={{ fontSize: 30, color: "#fff" }}
                onClick={() => toggleMenu(false)}
              />
            </div>
            <div className="pr-4">
              <LanguageSelection />
            </div>
          </div>
          <div
            style={{
              overflowY: "scroll",
              height: "calc(100vh - 60px)",
            }}
          >
            <ul className="">
              <li
                className="user_info menu"
                onClick={() => {
                  window.location.href = "/mypage";
                }}
                style={{ display: isAuthenticated ? "flex" : "none" }}
              >
                <i className="fas fa-sack-dollar"></i>
                <p className="" id="headerMoneyAmount">
                  <span className="">￦</span>
                  <span className="add-commas">
                    {!isEmpty(user.balance)
                      ? Number(user.balance.money).toLocaleString()
                      : "0"}
                  </span>
                </p>
              </li>
              <li
                className="menu"
                // ref={casinoLinkRef}
                // onMouseEnter={handleCasinoMouseEnter}
                // onMouseLeave={handleCasinoMouseLeave}
              >
                <i className="fas fa-spade"></i>
                <Link
                  focus-use=""
                  className="gameHyperLink on"
                  to="/casino"
                  gnb="0"
                  onClick={onClickMemMenu}
                >
                  {isEmpty(window.lang["라이브카지노"])
                    ? "라이브카지노"
                    : window.lang["라이브카지노"]}
                </Link>
              </li>
              <li
                className="menu"
                // ref={slotLinkRef}
                // onMouseEnter={handleSlotMouseEnter}
                // onMouseLeave={handleSlotMouseLeave}
              >
                <i className="fas fa-dice"></i>
                <Link
                  focus-use=""
                  className="gameHyperLink"
                  to="/Slot"
                  gnb="1"
                  onClick={onClickMemMenu}
                >
                  {isEmpty(window.lang["슬롯"]) ? "슬롯" : window.lang["슬롯"]}{" "}
                </Link>
              </li>
              <li className="menu">
                <i className="fas fa-futbol"></i>
                <Link
                  focus-use=""
                  className="gameHyperLink"
                  to="/sportsprematch"
                  gnb="2"
                  onClick={onClickMemMenu}
                >
                  {isEmpty(window.lang["스포츠"])
                    ? "스포츠"
                    : window.lang["스포츠"]}{" "}
                </Link>
              </li>
              <li className="menu">
                <i className="fas fa-video"></i>
                <Link
                  focus-use=""
                  className="gameHyperLink"
                  to="/sportslive"
                  gnb="2"
                  onClick={onClickMemMenu}
                >
                  {isEmpty(window.lang["라이브"])
                    ? "라이브"
                    : window.lang["라이브"]}{" "}
                </Link>
              </li>
              <li className="menu">
                <i className="fas fa-gamepad"></i>
                <Link
                  focus-use=""
                  className="gameHyperLink"
                  to="/esports"
                  gnb="2"
                  onClick={onClickMemMenu}
                >
                  {isEmpty(window.lang["E-스포츠"])
                    ? "E-스포츠"
                    : window.lang["E-스포츠"]}{" "}
                </Link>
              </li>
              <li className="menu">
                <i className="fas fa-clone"></i>
                <Link
                  focus-use=""
                  className="gameHyperLink"
                  to="/minigame"
                  gnb="2"
                  onClick={onClickMemMenu}
                >
                  {isEmpty(window.lang["미니게임"])
                    ? "미니게임"
                    : window.lang["미니게임"]}
                </Link>
              </li>

              <li className="menu">
                <i className="fas fa-bullhorn"></i>
                <Link to="/notices" onClick={onClickMemMenu}>
                  {isEmpty(window.lang["공지"]) ? "공지" : window.lang["공지"]}
                </Link>
              </li>
              <li className="menu">
                <i className="fas fa-gift"></i>
                <Link to="/events" onClick={onClickMemMenu}>
                  {isEmpty(window.lang["이벤트"])
                    ? "이벤트"
                    : window.lang["이벤트"]}
                </Link>
              </li>
              <li className="menu">
                <i className="fas fa-headset"></i>
                <Link to="/inquiries/question" onClick={onClickMemMenu}>
                  {isEmpty(window.lang["고객센터"])
                    ? "고객센터"
                    : window.lang["고객센터"]}
                </Link>
              </li>
              <li className="menu">
                <i className="fas fa-clipboard-check"></i>
                <Link to="/attendance" onClick={onClickMemMenu}>
                  {isEmpty(window.lang["출석체크"])
                    ? "출석체크"
                    : window.lang["출석체크"]}
                </Link>
              </li>

              <li
                className="menu"
                style={{ display: isAuthenticated ? "flex" : "none" }}
              >
                <i className="fas fa-money-bill"></i>
                <Link className="" to="/deposit">
                  {isEmpty(window.lang["입금"]) ? "입금" : window.lang["입금"]}
                </Link>
              </li>
              <li
                className="menu"
                style={{ display: isAuthenticated ? "flex" : "none" }}
              >
                <i className="fas fa-university"></i>
                <Link className="" to="/withdraw">
                  {isEmpty(window.lang["출금"]) ? "출금" : window.lang["출금"]}
                </Link>
              </li>
              <li
                className="menu"
                style={{ display: isAuthenticated ? "flex" : "none" }}
              >
                <i className="fas fa-clipboard-list"></i>
                <Link className="" to="/mypage/history">
                  {isEmpty(window.lang["베팅내역"])
                    ? "베팅내역"
                    : window.lang["베팅내역"]}
                </Link>
              </li>
              <li
                className="menu"
                style={{ display: isAuthenticated ? "flex" : "none" }}
              >
                <i className="fas fa-headset"></i>
                <Link className="" to="/inquiries/question">
                  {isEmpty(window.lang["고객센터"])
                    ? "고객센터"
                    : window.lang["고객센터"]}
                </Link>
              </li>
              <li
                className="menu"
                style={{ display: isAuthenticated ? "flex" : "none" }}
              >
                <i className="fas fa-comment"></i>
                <a href="/messages" style={{ display: "flex" }}>
                  <span className="ico_quick04"></span>
                  <p>
                    {" "}
                    {isEmpty(window.lang["쪽지"])
                      ? "쪽지"
                      : window.lang["쪽지"]}
                  </p>
                  <em className="count noticeCount ml-2">
                    {message.unreadNotes.length}
                  </em>
                </a>
              </li>
              <li
                className="header_btn_csnotice menu"
                style={{ display: isAuthenticated ? "flex" : "none" }}
              >
                <i className="fas fa-bullhorn"></i>
                <a href="/notices">
                  <span className="ico_quick05"></span>
                  <p>
                    {isEmpty(window.lang["공지"])
                      ? "공지"
                      : window.lang["공지"]}
                  </p>
                </a>
              </li>
              <li
                className="header_btn_csnotice menu"
                style={{ display: isAuthenticated ? "flex" : "none" }}
              >
                <i className="fa fa-sign-out"></i>
                <a href="/login">
                  <span className="ico_quick05"></span>
                  <p>
                    {isEmpty(window.lang["로그아웃"])
                      ? "로그아웃"
                      : window.lang["로그아웃"]}
                  </p>
                </a>
              </li>
              <li
                className="menu"
                style={{ display: isAuthenticated ? "none" : "flex" }}
              >
                <i className="fas fa-sign-in-alt"></i>
                <Link className="bt_login" to="/login">
                  {isEmpty(window.lang["로그인"])
                    ? "로그인"
                    : window.lang["로그인"]}
                </Link>
              </li>
              <li
                className="menu"
                style={{ display: isAuthenticated ? "none" : "flex" }}
              >
                <i className="fas fa-address-card"></i>
                <Link className="bt_join" to="register">
                  {isEmpty(window.lang["가입하기"])
                    ? "가입하기"
                    : window.lang["가입하기"]}
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </Fragment>
    );
  }
);

const mapStateToProps = (state) => ({
  isAuthenticated: state.user.isAuthenticated,
  user: state.user.data,
  slideBar: state.more.slideBar,
  unreadNotes: state.more.message.unreadNotes,
  language: state.more.language,
  message: state.more.message,
});

export default connect(mapStateToProps, {
  logoutUser,
  SetShowLeft,
  SetPageLoading,
})(Headbar);



// WEBPACK FOOTER //
// ./src/components/Layout/Headbar.js